import { Modal, Button } from 'react-bootstrap';

const ErrorModal = (props) => {
    const {
        isOpen,
        setModalOpen,
    } = props;

    const handleOnHide = () => {
        setModalOpen(!isOpen)
    }

    return (
        <Modal
            size="sm"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            show={isOpen}
            onHide={handleOnHide}
        >
            <div className='missing-data-modal'>
                <Modal.Body className='missing-data-modal-body'>
                    <form>
                        <p>Something went wrong while submitting your order. Please try again, or contact your lab if the problem continues.</p>
                    </form>
                </Modal.Body>
                <Modal.Footer>
                    <Button
                        variant="primary"
                        size="sm"
                        onClick={handleOnHide}
                    >
                        Return To Order
                    </Button>
                </Modal.Footer>
            </div>
        </Modal>
    )
}

export default ErrorModal;
